import React from "react";
import styled from "styled-components";
import * as MainTitle from "./components/Title";
import SearchCard from "./components/SearchCard";
import Wrapper from "./components/Wrapper";
import config from "../../../../../config/customers";

const {
  publicPortal: { mainSearchSection: MAIN_SEARCH_SECTION },
} = config;

const Container = styled.div`
  z-index: 1;
  width: 100%;
  @media (min-width: 768px) {
    width: auto;
  }
`;

const TitleSection = () => {
  return (
    <MainTitle.Container>
      <MainTitle.Title>{MAIN_SEARCH_SECTION.title}</MainTitle.Title>
      <MainTitle.Subtitle>{MAIN_SEARCH_SECTION.subtitle}</MainTitle.Subtitle>
    </MainTitle.Container>
  );
};

const MainSearchSection = () => {
  return (
    <Wrapper backgroundImage={MAIN_SEARCH_SECTION.backgroundImage}>
      <Container>
        <TitleSection />
        <SearchCard />
      </Container>
    </Wrapper>
  );
};

export default MainSearchSection;
